const Container = {
  baseStyle: {
    maxW: "1300px",
    px: "1.5rem",
  },
}

export default Container
